import React, { useState, useEffect } from "react";
import CgFormCreator from "../../../common/CgFormCreator";
import AddedValuesList from "../../../common/AddedValuesList";
import PopupModal from "../../../common/PopupModal";
import "./generalcertificate.scss";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  fetchProviderCertificationDetails,
  fetchProviderCertificationSuggesion,
  deleteProviderGeneralCert,
  saveProviderCertifications,
} from "../../../store/Experience/GeneralCertificationActions";
import { addUpdateProviderCertification } from "../../../store/Experience/GeneralCertificationReducer";

const GeneralCertification = ({
  providerId,
  onlyPopup = false,
  openCertificationPopup,
  closePopupCallback = () => { },
}) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmDeleteMap, setConfirmDeleteMap] = useState({});
  const [errorMsg, setErrorMsg] = useState("");
  const [renderErrorMsg, setRenderErrorMsg] = useState("");
  const [emptyQuery, setEmptyQuery] = useState(false);
  const [addedValues, setAddedValues] = useState([]);
  const [showError, setShowError] = useState(false);
  const location = useLocation();
  const locationData = location.pathname.split("/");
  const [prvId, setPrvId] = useState(providerId ? providerId : locationData[2]);

  const dispatch = useDispatch();

  const { certSuggestion } = useSelector(
    (state) => state.providerCertificationSuggesions
  );

  const { isCertDataLoading, certData, isSaving } = useSelector(
    (state) => state.providerCertificationDetails
  );

  useEffect(() => {
    setOpenPopup(openCertificationPopup);
  }, [openCertificationPopup]);

  useEffect(() => {
    if (providerId) {
      setPrvId(providerId);
    } else {
      setPrvId(locationData[2]);
    }
  }, [providerId]);

  useEffect(() => {
    if (certData && Array.isArray(certData)) {
      setAddedValues(certData);
    } else {
      setAddedValues([]);
    }
  }, [certData]);

  useEffect(() => {
    dispatch(fetchProviderCertificationSuggesion());
    dispatch(fetchProviderCertificationDetails(prvId));
  }, [prvId]);

  useEffect(() => {
    if (errorMsg) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 5000);
    } else {
      setShowError(false);
    }
  }, [errorMsg]);

  const handleCertificationSearch = (query) => {
    if (query && query.trim() !== "") {
      dispatch(fetchProviderCertificationSuggesion(query.trim()));
    }
  };

  const handleCertificationSelect = () => {
    setErrorMsg("");
  };

  const AddGeneralCertificationSchema = [
    {
      component: "autoComplete",
      emptySearchField: emptyQuery,
      id: "name",
      label: "CERTIFICATION",
      type: "text",
      name: "name",
      autoCompletePlaceHolders:
        "Type to search by organization or certification name",
      required: false,
      defaultValue: "",
      suggestions: Array.isArray(certSuggestion)
        ? certSuggestion.map((item) => ({
          id: item.name,
          name: item.name,
          value: item.name,
        }))
        : [],

      deleteItem: () => { },
      renderAddedValues: false,
      isMultiple: false,
      onValueSelect: (selectedValue) => {
        handleCertificationSelect(selectedValue);
      },
      onValueChangeCallback: (query) => {
        handleCertificationSearch(query);
      },
      onValueSave: () => { },
      errorCallback: () => {
        setErrorMsg("This certification already exists");
        setTimeout(() => {
          setErrorMsg("");
        }, 5000);
      },
      noErrorInAutoComplate: true,
    },
  ];

  const toggleConfirmDelete = (displayId, value) => {
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [displayId]: value,
    }));
  };

  const formatCertifications = (certifications) => {
    return certifications.map((cert) => ({ name: cert.name }));
  };

  const deleteAPiCall = async (deleteId) => {
    try {
      await dispatch(
        deleteProviderGeneralCert({
          providerId: prvId,
          certificationDisplayId: deleteId,
        })
      );

      setConfirmDeleteMap((prev) => ({
        ...prev,
        [deleteId]: false,
      }));

      await dispatch(fetchProviderCertificationDetails(prvId));
    } catch (error) {
      setErrorMsg(error.message || "Failed to delete certification");
    }
  };

  const renderGenCertAutoComplete = () => {
    if (isCertDataLoading) return null;
    return (
      <div>
        <CgFormCreator
          primaryButton="ADD"
          noCancel
          schema={AddGeneralCertificationSchema}
          onSubmitCallback={(val) => {
            setErrorMsg("");
            setRenderErrorMsg("");
            setShowError(false);

            if (val.name) {
              const validCertifications = addedValues && Array.isArray(addedValues)
                ? addedValues.filter(
                  (item) => item.isValid === "true" || item.isValid === true
                )
                : [];

              const existingCert = validCertifications.find(
                (item) => item.name.toLowerCase() === val.name.toLowerCase()
              );

              if (existingCert) {
                setErrorMsg("This certification already exists");
                setRenderErrorMsg("This certification already exists");
                return;
              }

              const addedValue = {
                name: val.name,
                displayId: Date.now().toString(20),
                isValid: "true",
              };

              const newValue = [...(addedValues || [])];
              newValue.push(addedValue);
              setAddedValues(newValue);
              setErrorMsg("");
              setRenderErrorMsg("");
              setEmptyQuery(true);
              setTimeout(() => {
                setEmptyQuery(false);
              }, 20);
            }
          }}
          onCancel={() => {
            setOpenPopup(false);
            closePopupCallback();
          }}
          showErrorMsg={renderErrorMsg}
        />
        <AddedValuesList
          key={addedValues ? JSON.stringify(addedValues) : "empty"}
          onSave={async (res) => {
            try {
              setErrorMsg("");
              setShowError(false);

              const currentCerts = certData || [];
              const resultIds = res.map((item) => item.id);
              const removedCerts = currentCerts.filter(
                (cert) =>
                  !resultIds.includes(cert.displayId) &&
                  (cert.isValid === "true" || cert.isValid === true)
              );

              for (const cert of removedCerts) {
                await dispatch(
                  deleteProviderGeneralCert({
                    providerId: prvId,
                    certificationDisplayId: cert.displayId,
                  })
                );
              }

              const result = res?.map((item) => {
                return item.metadata;
              });

              const validCertifications = result.filter(
                (item) => item.isValid === "true" || item.isValid === true
              );

              if (validCertifications.length > 0) {
                const formattedCertifications =
                  formatCertifications(validCertifications);
                await dispatch(
                  saveProviderCertifications({
                    providerId: prvId,
                    certifications: formattedCertifications,
                  })
                );
              }

              dispatch(addUpdateProviderCertification(result));
              await dispatch(fetchProviderCertificationDetails(prvId));

              setOpenPopup(!openPopup);
              setErrorMsg("");
              setRenderErrorMsg("");
              closePopupCallback("success");
            } catch (error) {
              setErrorMsg(error.message || "Failed to save certifications");
            }
          }}
          deleteCallback={(value, deleteItem) => {
            const newValue = addedValues?.filter(
              (value) => value?.displayId !== deleteItem?.id
            );
            setAddedValues(newValue);
          }}
          enableSave
          addedValuesHeading="Your General Certifications"
          primaryButton="SAVE"
          secondaryButton="CANCEL"
          addedValuesList={(addedValues || [])
            .filter((item) => item.isValid === "true" || item.isValid === true)
            .map((item) => {
              return {
                name: item.name,
                id: item.displayId,
                metadata: item,
              };
            })}
          onClose={() => {
            setOpenPopup(false);
            setErrorMsg("");
            setRenderErrorMsg("");
            setShowError(false);
            setAddedValues(certData);
            closePopupCallback();
          }}
        />
      </div>
    );
  };

  const renderAddGeneralCertPopup = () => {
    return (
      <div>
        <PopupModal
          customRender={renderGenCertAutoComplete}
          isOpen={openPopup}
          onSave={async () => {
            try {
              setErrorMsg("");
              setShowError(false);

              const validCertifications = addedValues && Array.isArray(addedValues)
                ? addedValues.filter(
                  (item) => item.isValid === "true" || item.isValid === true
                )
                : [];

              if (validCertifications && validCertifications.length > 0) {
                const formattedCertifications =
                  formatCertifications(validCertifications);
                await dispatch(
                  saveProviderCertifications({
                    providerId: prvId,
                    certifications: formattedCertifications,
                  })
                );

                dispatch(addUpdateProviderCertification(addedValues));
                await dispatch(fetchProviderCertificationDetails(prvId));
              }

              setOpenPopup(!openPopup);
              closePopupCallback("success");
            } catch (error) {
              setErrorMsg(error.message || "Failed to save certifications");
            }
          }}
          onClose={() => {
            setOpenPopup(!openPopup);
            setAddedValues(certData);
            setErrorMsg("");
            setShowError(false);
            closePopupCallback();
          }}
          popupHeading={"Add General Certifications"}
        />
      </div>
    );
  };

  const renderGeneralCertification = () => {
    if (isCertDataLoading) return null;

    const validCertifications = Array.isArray(certData)
      ? certData.filter((item) => item.isValid === "true" || item.isValid === true)
      : [];

    if (validCertifications.length === 0) {
      return (
        <div className="info-section ng-isolate-scope">
          <p className="empty-module ng-binding">
            No general certifications for this provider
          </p>
        </div>
      );
    }

    return (
      <div>
        {validCertifications.map((item) => {
          return (
            <React.Fragment key={item.displayId}>
              <div className="gencert-list">
                {item.name}
                <div className="deleteBtnwithConfirm">
                  {confirmDeleteMap[item.displayId] && (
                    <button
                      type="button"
                      className="btn border-0 canceldelete"
                      onClick={() =>
                        toggleConfirmDelete(item.displayId, false)
                      }
                    >
                      CANCEL
                    </button>
                  )}
                  <button
                    type="button"
                    className={`btn ${confirmDeleteMap[item.displayId]
                        ? "deleteConfirmation"
                        : "border-0"
                      }`}
                    onClick={() => {
                      if (confirmDeleteMap[item.displayId]) {
                        deleteAPiCall(item.displayId);
                      } else {
                        toggleConfirmDelete(item.displayId, true);
                      }
                    }}
                  >
                    {confirmDeleteMap[item.displayId]
                      ? "CONFIRM"
                      : "DELETE"}
                  </button>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  };


  const RenderCertificationErrors = () => {
    if (!showError || !errorMsg) return null;
    return (
      <div className="alert alert-danger" role="alert">
        {errorMsg}
      </div>
    );
  };

  return (
    <>
      {!onlyPopup && (
        <div className="general-Certificate">
          {isCertDataLoading || isSaving ? (
            <div>Loading ... </div>
          ) : (
            <>
              <h3 className="section-header top-thirty overview">
                General Certifications
                <a
                  className="btn edit-button"
                  onClick={() => {
                    setAddedValues(certData || []);
                    setOpenPopup(!openPopup);
                    setErrorMsg("");
                    setShowError(false);
                  }}
                >
                  +Add
                </a>
              </h3>
              <div className="general-certification-body">
                {RenderCertificationErrors()}
                {renderGeneralCertification()}
                {renderAddGeneralCertPopup()}
              </div>
            </>
          )}
        </div>
      )}
      {onlyPopup && (
        <div className="general-Certificate">{renderAddGeneralCertPopup()}</div>
      )}
    </>
  );
};
export default GeneralCertification;